import { atom } from 'jotai';

export interface MeshExportTracker {
  toastId: string | number;
  batchId: string;
  projectId: string;
  sourceLayerId: string;
  sourceLayerName: string;
}

export const meshExportTrackingAtom = atom<MeshExportTracker[]>([]);
